<template>
  <div class="mini-hub mini-training">
    <div class="featured-media" v-if="post.featured_image_url">
      <img :src="post.featured_image_url" alt="" class="img-fluid" />
    </div>

    <div class="inner">
      <div
        class="d-flex justify-content-between align-items-center wrapper-tags"
      >
        <etiquette v-bind:post-type="post.type" />

        <p class="duration m-0" v-if="post.duration" v-html="post.duration"></p>
      </div>

      <div
        class="date-wrapper d-flex align-items-center mb-1"
        v-if="post.date_event"
      >
        <div class="numero-jour me-3">{{ data_event_array[1] }}</div>
        <div class="reste-date">
          <p class="jour m-0" v-html="data_event_array[0]"></p>
          <p
            class="mois-annee m-0"
            v-html="data_event_array[2] + ', ' + data_event_array[3]"
          ></p>
        </div>
      </div>

      <h3 class="title" target="_blank" v-html="title_linked"></h3>

      <p
        class="excerpt"
        v-if="post.excerpt.rendered != ''"
        v-html="post.excerpt.rendered"
      ></p>

      <tags :tagsArray="post.tags" />

      <Button :link="post.external_link" :postType="post.type" />
    </div>
  </div>
</template>

<script>
import Etiquette from "../parts/Etiquette";
import Button from "../parts/Button";
import Tags from "../parts/Tags";

export default {
  name: "Training",
  components: {
    Etiquette,
    Button,
    Tags,
  },
  props: {
    post: Object,
  },
  computed: {
    data_event_array: function () {
      if (this.post.date_event) {
        return this.post.date_event.split("/");
      }
      return false;
    },
    title_linked: function () {
      return (
        '<a href="' +
        this.post.external_link +
        '">' +
        this.post.title.rendered +
        "</a>"
      );
    },
  },
};
</script>
